<div
  [matTooltip]="
    (isViewMode ? 'ASIDE_L.AI_EDIT_MODE_REQUIRED_TOOLTIP' : 'ASIDE_R.AGENTFORCE_GENERATE')
      | translate
  ">
  <q9-icon-button
    icon="wand"
    [matMenuTriggerFor]="agentforceMenu"
    [disabled]="isViewMode"
    [isLoading]="isLoading()"></q9-icon-button>
</div>

<mat-menu #agentforceMenu="matMenu" [overlapTrigger]="false">
  <button
    mat-menu-item
    q9Track="RIGHT_SIDEBAR.DIAGRAM.CONTEXT_MENU.GENERATE_INSTRUCTIONS"
    (click)="generateAgentforceData(AGENT_FORCE_DATA_TYPES.INSTRUCTIONS)">
    {{ 'ASIDE_R.AGENTFORCE_INSTRUCTIONS_OPTION' | translate }}
  </button>

  <button
    mat-menu-item
    q9Track="RIGHT_SIDEBAR.DIAGRAM.CONTEXT_MENU.GENERATE_UTTERANCES"
    [matTooltip]="'ASIDE_L.UTTERANCES_NOT_AVAILABLE_TOOLTIP' | translate"
    [matTooltipDisabled]="elementsGPTEnabled()"
    [disabled]="!elementsGPTEnabled()"
    (click)="generateAgentforceData(AGENT_FORCE_DATA_TYPES.UTTERANCES)">
    {{ 'ASIDE_R.AGENTFORCE_TEST_UTTERANCES_OPTION' | translate }}
  </button>
</mat-menu>
